
import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { Icon, Row, Col, Modal, Carousel} from "antd";
import MenuPortal from "../Portal/MenuPortal";
import './portal.css';

import Document0 from '../../../assets/img/Documents/docs_00.svg';
import Document1 from '../../../assets/img/Documents/docs_01.svg';
import Document2 from '../../../assets/img/Documents/docs_02.svg';
import Document3 from '../../../assets/img/Documents/docs_03.png';
import { fotos } from '../../../utils/Request/examples';





const Documentos = () => {
    function toTop() {
      window.scrollTo(0, 0);
    }

  const [photo, setPhoto] = useState(false); //Hook para mostrar el modal de ejemplos

      //Función que muestra el modal de ejemplo
  const modalPhoto = () => {
    return (
      <Modal
        title={null}
        visible={photo}
        onCancel={() => setPhoto(false)}
        footer={null}
        width={210}>
        <Carousel autoplay>
          {fotos.map((elem) => (
            <div key={elem.id}>
              <img
                src={elem.url}
                alt={elem.alt}
                style={{ height: "190px", marginTop: 20 }}
              />
            </div>
          ))}
        </Carousel>
      </Modal>
    );
  };

  
    useEffect(() => {
      toTop();
    }, []);
  

    


    return (
    <div className="interioresPortal new-design">
    
      <Row  gutter={24}>
      <Col xxl={{ span: 3 }} xl={{ span: 3  }}>
      <Link to={"/"} className="button-back">
        <Icon type="play-circle" theme="filled" rotate="180" /> Regresar
      </Link>
      </Col>
    
      <Col xxl={{ span: 21}} xl={{ span: 21}}>
      <MenuPortal active={'documentos'}/></Col>
      </Row>


    <h1 className="main-title">Documentos</h1>

    <Row gutter={24} className="interioresPortal new-design descript-title" >
        <Col xxl={{ span: 22, offset: 1 }} xl={{ span: 22, offset: 1  }} lg={{ span: 22, offset: 1  }} md={{ span: 22, offset: 1   }} sm={24} xs={24}>
          <p>Los siguientes documentos te permiten registrar tu solicitud de acreditación en este portal.</p>
        </Col>
    </Row>

    <Row gutter={24} className="interioresPortal new-design descript-lefttext" >
        <Col xxl={{ span: 12, offset: 6  }} xl={{ span: 12, offset: 6  }} lg={{ span: 16, offset: 4  }} md={{span: 16, offset: 4  }} sm={24} xs={24}>
            <li>Durante la captura de tu solicitud, también se genera el escrito de protesta.</li>
            <li>Si deseas participar como Observadora u Observador para la Jornada Electoral necesitas de un nuevo registro:</li>
        </Col>
    </Row>


    <Row gutter={24}  align="middle">
        <Col xxl={{ span: 10, offset: 2 }} xl={{ span: 10, offset: 2 }} lg={{ span: 10, offset: 2 }} md={{ span: 10, offset: 2 }} sm={24} xs={24}>
          
          <Row type="flex" justify="start">
          <Col span={24}>
            <div className="imgCont" style={{ marginBottom: "75px" }}>
                <img src={Document0} className="img-center" alt="Document0" />
                <img src={Document1} className="img-center" alt="Document1" />
            </div>
            </Col>
          <h2 className="sub-title"><ol><li><strong>Credencial de elector</strong></li></ol></h2>
          <Col span={24} >           
          <div className="interioresPortal new-design descript-lefttext">  
               <div>
                   <ul>
                       <li>Imágenes de ambos lados y que sean legibles.</li>
                       <li>
                           La credencial debe estar vigente.
                           <p><a href="https://listanominal.ine.mx/scpln/" target="_blank" rel="noopener noreferrer">Puedes consultar su vigencia aquí</a></p>
                       </li>
                   </ul>
               </div>
           </div>
            </Col>
          </Row>
        </Col>

        <Col xxl={{ span: 10, offset: 2 }} xl={{ span: 10, offset: 2 }} lg={{ span: 10, offset: 2 }} md={{ span: 10, offset: 2 }} sm={24} xs={24}>
          
          <Row type="flex" justify="start">
          <Col span={24}>
            <div className="imgCont">
                <img src={Document2} className="img-center" alt="Document2" />
                <img src={Document3} className="img-center" alt="Document3" />
            </div>
            </Col>
            {modalPhoto()}
          <h2 className="sub-title"><ol><li /><li><strong>Fotografía de retrato</strong></li></ol></h2>
            <Col span={24}>           
                <div className="interioresPortal new-design descript-lefttext">  
                    <div>
                    
                                <ul>
                                    <li>Tipo de fotografía infantil.</li>
                                    <li>Mirada al frente con rostro serio.</li>
                                    <li>Oídos descubiertos.</li>
                                    <li>Sin lentes, ni accesorios.</li>
                                    <li>Fondo de color claro, preferentemente blanco.</li>
                                    <li>
                                        <button className="btnExample" onClick={() => setPhoto(true)}>Ver ejemplos</button>
                                    </li>
                                </ul>
                    </div>
                </div>
             </Col>
          </Row>
        </Col>
      </Row>


      <Row gutter={24} className="interioresPortal new-design condicion" >
        <Col xxl={{ span: 22, offset: 1 }} xl={{ span: 22, offset: 1  }} lg={{ span: 22, offset: 1  }} md={{ span: 22, offset: 1   }} sm={24} xs={24}>
        <p>Cada archivo no debe superar los 5 MB. Los formatos permitidos son .png y .jpg</p>
        </Col>
    </Row>
    </div>
    );
}

export default Documentos;

